"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ErrorObserver = void 0;
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const contexts_1 = require("../../contexts");
const getComponent_1 = require("../../getComponent");
const MISSING_ERROR = Error('An unknown error occurred.');
const ErrorState = getComponent_1.getComponent('ErrorState');
/**
 * # 🚨 ErrorObserver
 *
 * Observes any exceptions in child tree hierarchy. When an exception is caught, displays
 * an Error state to gracefully handle it on the frontend.
 *
 * ## Usage
 * ```jsx
 * <ErrorObserver
 *  errorComponent={ErrorState}
 * >
 *  <Text>Rendered if there is no error here</Text>
 * </ErrorObserver>
 * ```
 */
class ErrorObserver extends react_1.default.Component {
    constructor() {
        super(...arguments);
        this.state = {
            error: undefined,
        };
    }
    componentDidCatch(e) {
        const error = e || MISSING_ERROR;
        if (this.props.onError) {
            this.props.onError(error);
        }
        this.setState({ error });
    }
    render() {
        const BB = this.context;
        const { error } = this.state;
        const _a = this.props, { children, retry, checkError, error: e, errorComponent } = _a, rest = tslib_1.__rest(_a, ["children", "retry", "checkError", "error", "errorComponent"]);
        if (error) {
            BB.Logger.error(error);
            const Error = this.props.errorComponent || ErrorState;
            return react_1.default.createElement(Error, Object.assign({ error, retry }, rest));
        }
        // 'children' as a function, 'render prop' pattern
        if (typeof children === 'function') {
            return children();
        }
        return children;
    }
}
exports.ErrorObserver = ErrorObserver;
ErrorObserver.contextType = contexts_1.BlueBaseContext;
ErrorObserver.defaultProps = {
    checkError: (props, state) => props.error || state.error,
};
ErrorObserver.getDerivedStateFromProps = (props, state) => ({
    error: props.checkError ? props.checkError(props, state) : undefined,
});
